import * as React from 'react';

import {LoadingSpinner} from './LoadingSpinner';

export const LoadingSpinnerPage: React.FC = (props) => {
  return <LoadingSpinner isVisible text='' />;
};

LoadingSpinner.displayName = 'LoadingSpinner';
